import { h } from 'preact';

import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Skeleton from '@mui/material/Skeleton';

import styles from '../../components/global.css';
import { UserTable } from './_common.jsx';
import LazyAdminUserRecord from '../../components/adminUserRecord/lazyAdminUserRecord.jsx';

function renderPlaceholder(_item, index) {
  return <LazyAdminUserRecord key={index} />;
}

export default function LazyAdminUserList(_props) {
  return (
    <Paper className={styles.originArea}>
      <Typography variant="h5" sx={{ mt: 1 }}>
        <Skeleton width={200} />
      </Typography>
      <UserTable>{Array(30).fill(null).map(renderPlaceholder)}</UserTable>
    </Paper>
  );
}
